import { render, staticRenderFns } from "./DashboardSeason.vue?vue&type=template&id=463555ea&scoped=true&"
import script from "./DashboardSeason.vue?vue&type=script&lang=ts&"
export * from "./DashboardSeason.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardSeason.vue?vue&type=style&index=0&id=463555ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463555ea",
  null
  
)

export default component.exports